import React from 'react';
import { Typography, useThemeCheck } from '../..';

/**
 * This implements the recommended UI for the header inside HelpButton. If
 * this doesn't fit your need, try to make sure you really need some other text
 * style.
 *
 * If you have very different needs, we would like to hear about them.
 */
export const HelpButtonContentHeader = ({
  children,
}: {
  children: React.ReactNode;
}): React.JSX.Element => {
  useThemeCheck();

  return <Typography.Heading level={6}>{children}</Typography.Heading>;
};
